// service.js
import { useApiHelper } from '../../utils/helper/apiHelper';

export const useWithdrawService = () => {
    const { post, loading } = useApiHelper();

    const getWalletBalance = async (payload: any) => {
        try {
            return await post(`${import.meta.env.VITE_APP_API_URL}/ExecuteProcedure`, payload);
        } catch (error) {
            console.error('Error fetching dashboard data:', error);
            throw error;
        }
    };
    const doWithdrawal = async (payload: any) => {
        try {
            return await post(`${import.meta.env.VITE_APP_API_URL}/ExecuteProcedure`, payload);
        } catch (error) {
            console.error('Error fetching dashboard data:', error);
            throw error;
        }
    };
    // const WithdrawBUSDT = async (payload: any) => {
    //     try {
    //         return await post(`${import.meta.env.VITE_APP_ADMIN_API_URL}/WithdrawBUSDT`, payload);
    //     } catch (error) {
    //         console.error('Error fetching dashboard data:', error);
    //         throw error;
    //     }
    // };

    const withdraw = async (payload: any) => {
    try {
        return await post(`${import.meta.env.VITE_APP_API_URL}/ExecuteProcedure`, payload);
    } catch (error) {
        console.error('Error during withdrawal:', error);
        throw error;
    }
};

    return {
        getWalletBalance,
        doWithdrawal,
        // WithdrawBUSDT,
        withdraw,
        loading,
    };
};
